/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $TeamAuditResponse = {
    properties: {
        id: {
            type: 'string',
            isRequired: true,
        },
        createdAt: {
            type: 'string',
            format: 'date-time',
        },
        createdById: {
            type: 'any-of',
            contains: [{
                type: 'number',
            }, {
                type: 'null',
            }],
            isRequired: true,
        },
        patch: {
            type: 'array',
            contains: {
                type: 'PatchEntryResponse',
            },
        },
        squad: {
            type: 'array',
            contains: {
                type: 'SquadEntryResponse',
            },
        },
        createdBy: {
            type: 'UserSmall',
            isRequired: true,
        },
    },
} as const;
